import { useTranslation } from 'react-i18next';
import { AccountFundingOption, FieldData } from 'vopay';
import { PaymentFieldDefault } from './types';
import { isPaymentScheduled, useFundingOptionField } from './useFundingOptionField';

export const useDestinationFields = (
  fundingOptions: AccountFundingOption[],
  isFetchingFundingOptions: boolean,
): FieldData<PaymentFieldDefault>[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'UseTransactionCreationFields' });

  const getSubtitle = (option: AccountFundingOption) => {
    if (option.Source === 'balance') {
      return t('Fields.Destination.vopayBalanceSubtitle', { defaultValue: 'Funds land in your balance instantly' });
    }
    return t('Fields.Destination.bankAccountSubtitle', { defaultValue: 'Settles in 1-3 business days' });
  };

  return useFundingOptionField(fundingOptions, isFetchingFundingOptions, {
    fieldName: 'Destination',
    translationPrefix: 'Destination',
    labelDefaultValue: 'Deposit Collected Funds To',
    showFee: false,
    showSettlementTime: false,
    showBalanceInlineSubtitle: false,
    excludeSources: ['credit'],
    getSubtitle,
    // Interac e-transfer requests aren't settled at submit time (the payer hasn't sent funds
    // yet), so there's no live transaction to sweep to the bank.
    isAdditionallyVisible: (values) =>
      values.PaymentSelectionMethod !== 'email' &&
      values.ProvideOrRequestPaymentInformation !== 'request' &&
      !isPaymentScheduled(values),
  });
};
